export const DEFAULT_PREMIUM_FINANCING_PROFILE = {
  principal: 1000000,
  base: 190000,
  loanPercentage: 80,
  bankLoanInterest: 2,
  policyInterest: 4.1,
  yearsToShow: [0, 8, 9, 10],
  cashValueAt: [1000000, 1300000, 1380000, 1500000],
  firstYearBonus: 10000,
  termLoanPercentage: null,
  termAddOn: null,
  overrideLoanInterest: false,
  day0SurrenderValue: 850000,
  bankLoanPercentage: 95,
  shouldPayPrincipal: 0,
  showIRR: false,
  /** Snapshot of linked illustration OCR result; null when not linked. */
  linkedIllustration: null,
  /** When false, realization rate is treated as 100% and the realization-rate slider is hidden. */
  returnRealizationRateEnabled: false,
  /** Realization rate (%) applied to linked illustration cash values. 80–120, step 1, default 100. */
  returnRealizationRate: 100,
  /** Loan interest calculator inputs (HIBOR / PRIME). */
  hiborBase: 3.484,
  hiborAddOn: 1.75,
  primeBase: 5.375,
  primeSubtract: 0.5
};
